import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "_grid _grid-cols-2 _grid-cols-3--m _gap-2",
  "data-qa": "recently-viewed-projects:Skeleton"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_skeleton_image = _resolveComponent("skeleton-image")
  const _component_skeleton_wrapper = _resolveComponent("skeleton-wrapper")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (n) => {
      return _createVNode(_component_skeleton_wrapper, { key: n }, {
        default: _withCtx(() => [
          _createVNode(_component_skeleton_image, {
            class: "_rounded--common _bxsh--base",
            loading: "lazy"
          })
        ]),
        _: 1 /* STABLE */
      })
    }), 64 /* STABLE_FRAGMENT */))
  ]))
}